module.exports = __webpack_public_path__ + "img/_madison.dff198c3.png";